import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { EndpointKey } from '../http/EndpointKey';
import imageUrls from '../images/imageUrls';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';
import { jsx as _jsx } from "react/jsx-runtime";
const WordpressAuthorizationErrorView = () => {
  const errorKey = ErrorKey.WordpressAuthorizationError;
  const dispatch = useDispatch();
  const handleButtonClick = useCallback(() => dispatch(retryEndpoint(EndpointKey.WordpressAuthorization)), [dispatch]);
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey,
    handleButtonClick: handleButtonClick,
    imageURL: imageUrls.computerError
  });
};
export default WordpressAuthorizationErrorView;